import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import DigitalArchive from './pages/DigitalArchive/DigitalArchive';
import DigitalArchiveLP from './pages/DigitalArchive/DigitalArchiveLP';
import ThankYou from './pages/DigitalArchive/ThankYou';
import PrivacyPolicy from './pages/About/PrivacyPolicy';
import Terms from './pages/About/Terms';
import theme from './config/theme';
import ScrollToTop from './utils/toTop';

function App() {

  var redirectUrl =window.location.protocol + '//' + window.location.hostname + ':' + (window.location.port == "62293" ? "5000" : "/identity") + '/account/register';
  return (
      <ThemeProvider theme={theme}>
        <Router basename="/welcome">
        <ScrollToTop>
            <Switch>
                        <Route exact path='/' component={() => {
                          window.location.href = redirectUrl;
                            return null;
                        }} />
                <Route path="/privacy-policy" component={PrivacyPolicy} />
                <Route path="/terms" component={Terms} />
                        <Route component={() => {
                          window.location.href = redirectUrl;
                            return null;
                        }} />{/*Page not found 404*/}
            </Switch>
        </ScrollToTop>
      </Router>
    </ThemeProvider>
  );
}

export default App;
/*
<Switch>
    <Route exact path="/backoffice/landing-pages" component={LandingPagesIndex} />
    <Route path="/backoffice/landing-pages/create" component={LandingPagesCreate} />
    <Route path="/backoffice/landing-pages/update/:slug" component={LandingPagesDetails} />
</Switch>

<Route path="/plans/:type/:slug" component={PlanDetails} />

*/